import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useCallback } from 'react';
import SearchSelect from '../../../components/SearchSelect';
import { useIndustries } from '../industryQueries';

const mapIndustryToOption = ({
  name,
  id
}) => ({
  text: name,
  value: id
});

const mapOptionToIndustry = ({
  text,
  value
}) => ({
  name: text,
  id: value
});

const IndustrySelect = ({
  value,
  placeholder,
  onChange = () => {}
}) => {
  const handleChange = v => {
    onChange(v ? mapOptionToIndustry(v) : null);
  };

  const valueAsOption = value ? mapIndustryToOption(value) : null;
  const {
    getIndustries
  } = useIndustries();
  const handleLoadMore = useCallback((input, callback, pagination = {
    offset: 0
  }) => {
    getIndustries(input, pagination.offset).then(data => {
      callback(null, {
        options: data.results.map(mapIndustryToOption),
        pagination: {
          hasMore: data.hasMore,
          length: data.total,
          offset: data.offset
        }
      });
    }).catch(() => {});
  }, [getIndustries]);
  return /*#__PURE__*/_jsx(SearchSelect, {
    "aria-label": I18n.text('connectDotCom.industrySearch'),
    placeholder: placeholder,
    "data-test-id": "industry-search-input",
    onChange: handleChange,
    value: valueAsOption,
    loadOptions: handleLoadMore
  });
};

export default IndustrySelect;